import store from '@/core/store';
import devices from '@/apps/service_center/devices/store';
import contractors from '@/apps/service_center/store/contractors';

export const connect = (opts = {}) => {
  store.registerModule('service-center$devices', devices);
  store.registerModule('service-center$contractors', contractors);
};
